"use client";

import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

interface CustomPasswordInputProps {
  label?: string;
  placeHolder?: string;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  id?: string;
  value?: string;
}

export const CustomPasswordInput = ({
  label,
  placeHolder,
  onChange,
  disabled = false,
  error,
  helperText,
  id,
  value,
}: CustomPasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="">
      {label && (
        <label htmlFor={id} className={"mb-[0.3rem] " + (error ? "text-red-500" : "")}>
          {label}
        </label>
      )}

      <div
        className={
          "flex items-center bg-white dark:bg-transparent dark:text-white rounded-md border w-full h-[55px] pr-[8px] overflow-hidden " +
          (error ? "border-red-500" : "border-[#dedede]")
        }
      >
        <input
          type={showPassword ? "text" : "password"}
          placeholder={placeHolder || ""}
          onChange={onChange}
          disabled={disabled}
          id={id}
          value={value}
          className="outline-none text-[15px] px-[15px] placeholder:text-[#5a5a5a] flex-1 h-full"
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="transition-all hover:bg-[#eee] rounded-full p-[7px] text-[#555]"
          aria-label="Show Password"
        >
          {showPassword ? <FaEyeSlash size={17} /> : <FaEye size={17} />}
        </button>
      </div>

      {error && helperText && <span className="mt-2 text-sm text-red-500">{helperText}</span>}
    </div>
  );
};
